<template>
  <div v-if="infosPage.id_template === undefined">
    <h3 class="mb-15 mt-15 w-full text-center">
      Veuillez définir un modèle de page pour ce type d'évaluation.
    </h3>
  </div>
  <div
    v-else
    class="mx-5 lg:mx-15 2xl:mx-20"
    @keydown="progressbar.userKeyDown()"
    @keyup="progressbar.userKeyUp()"
    @click="calculate_progress"
  >
    <!-- Popup modal create evaluation -->
    <create-evaluation-popup
      :is-opened="show_add_evaluation"
      :date-debut="form.date_debut_evaluation"
      :date-fin="form.date_fin_evaluation"
      @close="show_add_evaluation = false"
      @changeDateDebut="
        (newValue) => {
          if (
            form.date_fin_evaluation == '' ||
            $verifyDates({ debut: newValue, fin: form.date_fin_evaluation })
          ) {
            form.date_debut_evaluation = newValue;
          } else {
            badDates();
            form.date_debut_evaluation = '';
          }
        }
      "
      @changeDateFin="
        (newValue) => {
          if (
            form.date_debut_evaluation == '' ||
            $verifyDates({ debut: form.date_debut_evaluation, fin: newValue })
          ) {
            form.date_fin_evaluation = newValue;
          } else {
            badDates();
            form.date_fin_evaluation = '';
          }
        }
      "
      @createEvaluation="create_evaluation"
    />
    <!-- END Popup modal create evaluation -->

    <!-- BEGIN Popup to confirm to close an evaluation -->
    <close-evaluation-popup
      :is-opened="confirmCloseEvaluation > -1"
      :is-step-one="confirmCloseEvaluation == 0"
      :is-step-two="confirmCloseEvaluation == 1"
      :today="today"
      @close="confirmCloseEvaluation = -1"
      @closeEval="close_eval"
    />
    <!-- END Popup to confirm to close an evaluation -->

    <h3 class="my-15 w-full">
      {{ infosPage.libelle_template }}
    </h3>

    <!-- BEGIN Button add evaluation -->
    <div
      v-if="
        form.date_debut_evaluation == '' ||
        form.date_fin_evaluation == '' ||
        form.id_ref == 0 ||
        form.template == {}
      "
    >
      <div
        v-if="role === constants.ROLE_BENEFICIAIRE"
        class="flex justify-center mb-10"
      >
        <change-structure-input class="w-max" />
      </div>
      <div
        v-if="
          $can(infosPage.name_page + '_edit', infosPass.id_pass) &&
          (role !== constants.ROLE_BENEFICIAIRE || $freeParticulier())
        "
      >
        <div class="flex justify-center w-full">
          <action-button
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-indigo-600"
            bg-color-square="bg-indigo-600"
            icon-color="text-white"
            libelle="AJOUTER UNE ÉVALUATION"
            :uppercase="true"
            icon="plus-circle"
            type-shadow="shadow-indigo"
            @clickAction="show_add_evaluation = true"
          />
        </div>
        <div class="flex justify-center w-full">
          <illustration name="evaluation" class="mt-15" />
        </div>
      </div>
      <div v-else>
        <div class="text-indigo-600 text-lg text-center">
          Il n’y a pas d’évaluation en cours
          <span v-if="listEvaluationsNeopass.length > 0">
            , vous pouvez consulter
            <br />
            vos évaluations précédentes dans l’historique ci-dessous
          </span>
          .
        </div>
        <div class="flex justify-center w-full">
          <illustration name="notAllowed" class="mt-15" />
        </div>
      </div>
    </div>
    <!-- END Button add evaluation -->

    <!-- BEGIN Evaluation content -->
    <div v-else>
      <!-- data comes from CompetenceChart mixin -->
      <PopupCompareCarto
        :compare-carto="compareCarto"
        @close="closeCompare"
        @changeCompare="
          (index) => {
            changeCompare(index);
          }
        "
        :carto-to-compare="cartoToCompare"
        :history-to-display="historyToDisplay"
        :competences-cles="{}"
        :history-competences-cles="{}"
        :competences-informatique="{}"
        :history-competences-informatique="{}"
        :competences-linguistique="competencesLinguistique"
        :history-competences-linguistique="
          historyCompetencesLinguistique[1].filter(
            (hist) =>
              hist.template_name ==
              competencesLinguistique[form.items[0].name].template_name
          )
        "
        :competences-socio-pro="{}"
        :history-competences-socio-pro="{}"
        v-if="compareCarto"
      />

      <div
        v-if="role === constants.ROLE_BENEFICIAIRE"
        class="flex justify-center mb-10"
      >
        <change-structure-input class="w-max" />
      </div>

      <!-- Bloc action buttons -->
      <div
        v-if="
          (role !== constants.ROLE_BENEFICIAIRE &&
            $can(infosPage.name_page + '_edit', infosPass.id_pass)) ||
          $freeParticulier()
        "
        class="w-full mb-15 2xl:mb-20 flex justify-center"
      >
        <list-action-buttons
          :today="today"
          :libelle-template="infosPage.libelle_template"
          :can-compare-cartography="canCompare && listEvaluations.length > 0"
          :can-compare-but-not-enough-evaluation="
            canCompare && listEvaluations.length === 0
          "
          @confirmCloseEvaluation="confirmCloseEvaluation = 0"
          @displayCompareCarto="
            displayCompareCarto(
              constants.PAGE_NEOPASS_FORM_COMPETENCES_LINGUISTIQUES
            )
          "
        />
      </div>
      <!-- Bloc action buttons -->

      <!-- BEGIN Button to add a "langue" -->
      <div
        class="w-max cursor-pointer flex hover:font-medium mb-5"
        @click="addLangue"
        v-if="$can(infosPage.name_page + '_edit', infosPass.id_pass)"
      >
        <span class="plus-button 2xl:h-10 2xl:w-10">
          <icon name="plus" />
        </span>
        <span class="text-base text-gray-600 ml-3 mt-1.5 flex-initial">
          Ajouter une langue
        </span>
      </div>
      <!-- END Button to add a "langue" -->

      <!-- BEGIN referentiel multi 1 -->
      <div
        v-if="['multi1', 'ref_multi1'].includes(form.type_temp)"
        class="mt-10"
      >
        <div
          v-for="(langue, indexLangue) in form.items"
          :key="indexLangue"
          class="mb-10"
        >
          <p
            class="text-base text-indigo-600 uppercase font-normal w-full mb-5"
          >
            Langue {{ indexLangue + 1 }} : {{ langue.name }}
          </p>

          <div class="grid grid-cols-12 gap-x-4 gap-y-10">
            <div
              v-for="(field, jndex) in form.template"
              :key="jndex"
              class="col-span-full md:col-span-3 flex space-x-4 items-center"
              :class="{
                'lg:col-start-1': jndex == 1,
                'col-span-full md:col-span-4': jndex == 0,
              }"
            >
              <!-- BEGIN Button to delete a "langue" -->
              <delete-button
                v-if="
                  $can(infosPage.name_page + '_edit', infosPass.id_pass) &&
                  jndex == 0
                "
                class="mt-6 md:mt-7"
                @del="deleteLangue(form.items, indexLangue)"
              />
              <!-- END Button to delete a "langue" -->

              <!-- use $set function to be reactive with form watch property -->
              <input-text
                v-if="field.type == 'text' && jndex == 0"
                :necessary="true"
                :libelle="field.libelle"
                :value="langue.name"
                @input="
                  (newValue) => {
                    langue.name = newValue;
                  }
                "
              />
              <input-text
                v-else-if="field.type == 'text' && jndex > 0"
                :necessary="true"
                :libelle="field.libelle"
                :value="langue.criterions[jndex]"
                @input="
                  (newValue) => {
                    $set(langue.criterions, jndex, newValue);
                  }
                "
              />
              <input-select
                v-else-if="field.type == 'multi'"
                :necessary="true"
                :name="
                  field.libelle
                    .toLowerCase()
                    .replace(' ', '_')
                    .replace('\'', '') + indexLangue
                "
                :libelle="field.libelle"
                :value="langue.criterions[jndex]"
                @input="
                  (newValue) => {
                    $set(langue.criterions, jndex, newValue);
                  }
                "
                :datas="field.criterions"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- END referentiel multi 1 -->

      <!-- BEGIN referentiel europeen -->
      <div v-if="form.type_temp == 'euro'" class="mt-10">
        <div v-if="form.items.length > 0">
          <div
            class="text-lg text-gray-600 h-16 lg:h-24 2xl:h-32 font-normal grid grid-cols-12 gap-x-4 place-content-center mt-5"
          >
            <div class="col-start-3 lg:col-start-2 col-span-5 md:col-span-2">
              Langue
            </div>
            <div class="hidden lg:inline-block col-span-2">Comprendre</div>
            <div class="hidden lg:inline-block col-span-4">Parler</div>
            <div class="hidden lg:inline-block col-span-2">Ecrire</div>
            <div class="col-span-5 md:col-span-1 -ml-5">Global</div>
          </div>

          <!-- BEGIN list of activité -->
          <div
            v-for="(langue, indexLangue) in form.items"
            :key="indexLangue"
            class="odd:bg-indigo-100 odd:bg-opacity-50"
          >
            <!-- BEGIN Informations on accordion -->
            <div
              class="h-16 lg:h-24 2xl:h-32 hover:bg-indigo-200 grid grid-cols-12 gap-x-4 place-content-center cursor-pointer"
              :class="{
                'bg-indigo-200 border-l-2 border-indigo-600':
                  langueDisplayed == indexLangue,
              }"
              @click="displayLangue(indexLangue)"
            >
              <icon
                class="text-pink-600 col-span-2 md:col-span-1 place-self-center transform transition-transform ease-in-out duration-300"
                :class="{ 'rotate-90': langueDisplayed == indexLangue }"
                name="chevron-right"
              />
              <div
                class="col-span-5 md:col-span-2 text-base text-indigo-600 font-normal flex items-center overflow-y-hidden"
              >
                <!-- Langue -->
                {{ langue.name }}
              </div>
              <div
                class="hidden lg:inline-block col-span-2 text-base font-normal place-self-center justify-self-start"
              >
                <!-- Comprendre -->
                <div>
                  Ecouter :
                  <span class="text-pink-600">{{ langue.criterions[1] }}</span>
                </div>
                <div>
                  Lire :
                  <span class="text-pink-600">{{ langue.criterions[2] }}</span>
                </div>
              </div>
              <div
                class="hidden lg:inline-block col-span-4 text-base font-normal place-self-center justify-self-start"
              >
                <!-- Parler -->
                <div>
                  Prendre part à une conversation :
                  <span class="text-pink-600">{{ langue.criterions[3] }}</span>
                </div>
                <div>
                  S’exprimer oralement en continu :
                  <span class="text-pink-600">{{ langue.criterions[4] }}</span>
                </div>
              </div>
              <div
                class="hidden lg:inline-block col-span-2 text-base font-normal place-self-center justify-self-start"
              >
                <!-- Ecrire -->
                <div>
                  Ecrire :
                  <span class="text-pink-600">{{ langue.criterions[5] }}</span>
                </div>
              </div>
              <div
                class="col-span-5 md:col-span-1 text-base text-indigo-600 font-normal place-self-center mr-15 2xl:mr-20"
                v-if="langue.average && langue.average != ''"
              >
                <!-- Global -->
                {{ langue.average }}
              </div>
            </div>
            <!-- END Informations on accordion -->
            <transition
              enter-active-class="ease-out duration-300"
              enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enter-to-class="opacity-100 translate-y-0 sm:scale-100"
              leave-active-class="ease-in duration-200"
              leave-class="opacity-100 translate-y-0 sm:scale-100"
              leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <!-- BEGIN Form content -->
              <div
                v-show="langueDisplayed === indexLangue"
                class="bg-white p-5 md:p-15 grid grid-cols-12 gap-x-4 gap-y-10"
              >
                <div
                  v-for="(field, jndex) in form.template"
                  :key="jndex"
                  class="col-span-full md:col-span-6 flex"
                  :class="{ 'lg:col-start-1': jndex == 1 }"
                >
                  <!-- use $set function to be reactive with form watch property -->
                  <input-text
                    v-if="field.type == 'text' && jndex == 0"
                    :libelle="field.libelle"
                    :necessary="true"
                    :value="langue.name"
                    @input="
                      (newValue) => {
                        langue.name = newValue;
                      }
                    "
                  />
                  <input-text
                    v-else-if="field.type == 'text' && jndex > 0"
                    :libelle="field.libelle"
                    :necessary="true"
                    :value="langue.criterions[jndex]"
                    @input="
                      (newValue) => {
                        $set(langue.criterions, jndex, newValue);
                        calculateAverage(indexLangue);
                      }
                    "
                  />
                  <input-select
                    v-else-if="field.type == 'multi'"
                    :name="
                      field.libelle
                        .toLowerCase()
                        .replace(' ', '_')
                        .replace('\'', '') + indexLangue
                    "
                    :libelle="field.libelle"
                    :necessary="true"
                    :value="langue.criterions[jndex]"
                    @input="
                      (newValue) => {
                        $set(langue.criterions, jndex, newValue);
                        calculateAverage(indexLangue);
                      }
                    "
                    :datas="field.criterions"
                  />
                </div>
                <!-- BEGIN button to delete a langue -->
                <div
                  class="col-span-full lg:col-start-1 md:col-span-3 w-max-content w-max cursor-pointer flex text-gray-600 hover:font-medium items-center"
                  @click="deleteLangue(form.items, indexLangue)"
                >
                  <span class="minus-button 2xl:h-10 2xl:w-10 2xl:mt-2">
                    <icon name="close" />
                  </span>
                  <span class="text-base ml-3"> Supprimer cette langue </span>
                </div>
                <!-- END button to delete an langue -->
              </div>
              <!-- END Form content -->
            </transition>
          </div>
          <!-- END list of langue -->
        </div>
      </div>
      <!-- END referentiel europeen -->
    </div>
    <!-- END Evaluation content -->
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

import InputText from '../../../components/Inputs/InputText';
import InputTextArea from '../../../components/Inputs/InputTextArea';
import InputSelect from '../../../components/Inputs/InputSelect';
import MultipleSelect from '../../../components/Inputs/MultipleSelect';
import DatePicker from '../../../components/Inputs/DatePicker';
import CheckboxGreen from '../../../components/Inputs/CheckboxGreen';
import CheckboxForm from '../../../components/Inputs/CheckboxForm';

import ActionButton from '../../../components/ActionButton';
import Icon from '../../../components/Icon';
import Illustration from '../../../components/Illustration';
import Popup from '../../../components/Popup';
import ChangeStructureInput from '../../../components/ChangeStructureInput.vue';

import axios from './../../../api';
import VerifyDates from '../../../mixins/VerifyDates';
import PopupCompareCarto from '../../../components/Cartographies/PopupCompareCarto';

import CreateEvaluationPopup from '../../../components/Evaluations/CreateEvaluationPopup.vue';
import ListActionButtons from '../../../components/Evaluations/ListActionButtons.vue';
import CloseEvaluationPopup from '../../../components/Evaluations/CloseEvaluationPopup.vue';

import Constants from './../../../constants/';
import DeleteButton from '../../../components/Inputs/DeleteButton.vue';

export default {
  components: {
    PopupCompareCarto,
    ActionButton,
    InputText,
    InputTextArea,
    InputSelect,
    MultipleSelect,
    DatePicker,
    CheckboxGreen,
    CheckboxForm,
    Icon,
    Illustration,
    Popup,
    CreateEvaluationPopup,
    ListActionButtons,
    CloseEvaluationPopup,
    DeleteButton,
    ChangeStructureInput,
  },

  props: ['progressbar'],

  name: 'Maitrisedeslangues',

  mixins: [VerifyDates],

  data() {
    return {
      // Initial state of the form
      form: {
        id_ref: 0,
        version_template: 0,
        type_temp: '',
        name_temp: '',
        template: [],
        date_debut_evaluation: '',
        date_fin_evaluation: '',
        items: [],
      },

      show_add_evaluation: false,
      selectedDate: null,
      confirmCloseEvaluation: -1, //-1 : modal closed / 0 : confirm close / 1 : evaluation closed

      langueDisplayed: -1,

      cartoToCompare: '',
      compareCarto: false,
      colors: {
        type: 'normal',
        beneficiary: '#21B8C8',
        referent: '#FF1C80',
        true: '#21B8C85A',
        false: '#919AA65A',
      },
      historyToDisplay: -1,

      constants: Constants,
    };
  },
  async mounted() {
    await this.initForm(); // asynchrone function to wait do actions, then re-pass isFormChanged to false (actions in form pass this var to true)

    this.calculate_progress();
    this.infosPage.isFormChanged = false; // here, change value of isFormChanged to false to indicate that there is not change in form
  },
  methods: {
    ...mapMutations({
      SET_FORMCONTENT: 'neopass/SET_FORMCONTENT',
      calculate_progress: 'neopass/calculate_progress',
    }),

    ...mapActions({
      save_datas: 'neopass/save_datas',
      close_evaluation: 'neopass/close_evaluation',
      load_infos_pass: 'cartographiesIndividuelles/load_infos_pass',
      load_evaluations: 'cartographiesIndividuelles/load_evaluations',
    }),

    initForm() {
      //load values in form and keep formContent with initial values to compare when leave page without saving
      Object.assign(this.form, this.formContent);
    },

    create_evaluation() {
      if (
        this.role !== Constants.ROLE_BENEFICIAIRE ||
        this.$freeParticulier()
      ) {
        this.form.id_ref = this.infosPage.id_template;

        axios
          .get('/api/page_templates/' + this.form.id_ref)
          .then((response) => {
            /* Load template for the form */
            let datas = response.data.data;
            let last_version = datas[datas.length - 1];

            this.form.version_template = datas.length;
            this.form.type_temp = response.data.type;
            this.form.name_temp = response.data.name;

            if (last_version.length > 0) {
              this.form.template = last_version;
            } else {
              this.form.template = [];
            }
          })
          .catch((error) => {
            console.log('ERRRR:: ', error.response.data);
          });

        this.show_add_evaluation = false;
      }
    },

    addLangue() {
      //prepare list of criterions to add default values. it deserves to satisfy reactivity in vuejs and the form watched
      let crits = [];

      if (this.form.type_temp == 'euro') {
        var i = 0;
      } else if (['multi1', 'ref_multi1'].includes(this.form.type_temp)) {
        var i = 1;
      }

      for (let index = i; index < this.form.template.length; index++) {
        //first case in template array is the langue's name
        crits.push('');
      }

      this.form.items.push({ name: '', criterions: crits, average: '' });

      this.langueDisplayed = this.form.items.length - 1;
    },

    calculateAverage(indexLangue) {
      let levels = {
        D2: 1,
        D1: 2,
        C2: 3,
        C1: 4,
        B2: 5,
        B1: 6,
        A2: 7,
        A1: 8,
      };

      let cumul = 0;
      let nbFilled = 0;

      this.form.items[indexLangue].criterions.forEach((crit) => {
        if (crit != '' && crit != undefined && crit != null) {
          cumul += levels[crit];
          nbFilled++;
        }
      });

      let average = parseInt(cumul / nbFilled);

      this.form.items[indexLangue].average = Object.keys(levels)[average - 1];
    },

    deleteLangue(el, index) {
      el.splice(index, 1);
      this.langueDisplayed = -1;
    },

    close_eval() {
      this.close_evaluation(this.form);
      (this.form = {
        id_ref: 0,
        version_template: 0,
        type_temp: '',
        name_temp: '',
        template: [],
        date_debut_evaluation: '',
        date_fin_evaluation: '',
        items: [],
      }),
        (this.confirmCloseEvaluation = 1);
    },

    displayLangue(indexLangue) {
      if (this.langueDisplayed == indexLangue) {
        this.langueDisplayed = -1;
      } else {
        this.langueDisplayed = indexLangue;
      }
    },

    async displayCompareCarto(typeCarto) {
      await this.load_infos_pass(this.infosPass.id_pass);

      Promise.all([this.load_evaluations()])
        .then(() => {
          this.compareCarto = true;
          this.cartoToCompare = typeCarto;
        })
        .catch((error) => {
          console.error(`Error while loading page: ${error}`);
        });
    },

    closeCompare() {
      this.compareCarto = false;
      this.cartoToCompare = '';
      this.historyToDisplay = -1;
    },

    changeCompare(index) {
      setTimeout(() => {
        this.historyToDisplay = -1;
      }, 300);
      setTimeout(() => {
        this.historyToDisplay = index;
      }, 300);
    },
  },
  computed: {
    ...mapGetters({
      formContent: 'neopass/formContent',
      infosPage: 'neopass/infosPage',
      infosPass: 'neopass/infosPass',
      neopassDatas: 'cartographiesIndividuelles/neopassDatas',
      listEvaluations: 'cartographiesIndividuelles/listEvaluations',
      role: 'auth/role',
      listEvaluationsNeopass: 'neopass/listEvaluations',
    }),

    // TODO handle langues cartography
    canCompare() {
      return this.$can(Constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE);
    },

    today() {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date().toLocaleDateString(undefined, options);
    },

    evalStartDate() {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      if (this.form.date_debut_evaluation !== '') {
        return new Date(this.form.date_debut_evaluation).toLocaleDateString(
          undefined,
          options
        );
      } else {
        return new Date().toLocaleDateString(undefined, options);
      }
    },

    competencesLinguistique() {
      let comp =
        (this.neopassDatas || {})[
          Constants.PAGE_NEOPASS_FORM_COMPETENCES_LINGUISTIQUES
        ] || {};
      let langues = {};

      if (Object.keys(comp).length > 0) {
        comp.values.forEach((langue) => {
          langues[langue.title] = comp;
          langues[langue.title].values = langue;
          langues[langue.title].date_fin_eval = new Date();
        });
      }

      return langues;
    },

    historyCompetencesLinguistique() {
      return (
        (this.listEvaluations || {})[
          Constants.PAGE_NEOPASS_FORM_COMPETENCES_LINGUISTIQUES
        ] || []
      );
    },
  },
  watch: {
    form: {
      handler() {
        //assign true to flag to know if there is a change in form
        this.infosPage.isFormChanged = true;
      },
      deep: true,
    },
  },
};
</script>
